"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryPage = void 0;
/* Package Imports */
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
/* Blast Imports */
var PackagesApi = __importStar(require("@app/services/api/packages"));
var faspexUrlHelper_1 = require("@app/services/faspexUrlHelper");
var constants_1 = require("@app/shared/constants");
// import Log from '@app/shared/log';
var utils_1 = require("@app/shared/utils");
var initialState = {
    redirectUrl: '/dash',
    validating: true
};
// Deliver page url examples
// eslint-disable-next-line
// https://localhost:8888/packages/delivery?faspexUrl=https://usnpdaspfast12.na.hasbro.com/aspera/faspex?context=eyJyZXNvdXJjZSI6InBhY2thZ2VzIiwidHlwZSI6InBhY2thZ2VzX3JlY2VpdmVkIiwiaWQiOiIxMjQzNCIsImxvY2FsIjpmYWxzZSwiYWNjb3VudCI6IjEyMjA1N2QwNjkyZjJiMjJiMjYyMzJiNDg5MTdjYWVhIiwic2FtbF9wcm92aWRlciI6MX0=&recipient=Joshua.Skuby@Hasbro.com
// eslint-disable-next-line
// /packages/delivery?faspexUrl=https://test-faspex.hasbro.com/aspera/faspex?context=eyJyZXNvdXJjZSI6InBhY2thZ2VzIiwidHlwZSI6InBhY2thZ2VzX3JlY2VpdmVkIiwiaWQiOiIxMjQ3NCIsImxvY2FsIjpmYWxzZSwiYWNjb3VudCI6IjVjODdkNTM0NWRjYjc0NTAyMDI3YTdkYmJkZWUxZGViIiwic2FtbF9wcm92aWRlciI6MX0=&recipient=Nick.Nauges@hasbro.com
// eslint-disable-next-line
// /packages/delivery?faspexUrl=https://test-faspex.hasbro.com/aspera/faspex?context=eyJyZXNvdXJjZSI6InBhY2thZ2VzIiwidHlwZSI6InBhY2thZ2VzX3JlY2VpdmVkIiwiaWQiOiIxMjQ3NCIsImxvY2FsIjpmYWxzZSwiYWNjb3VudCI6IjlkOGM2MDQ2MGY5ZjI2ZmQ5YTVkMTEwNDNjZDBlYTBjIn0=&recipient=andrewwillis25@gmail.com
/**
 * Landing page for package downloads
 *
 * The upgrade to Faspex5 changed the make-up of the Faspex received package email urls, including the intended recipient's email.
 * This page is used to validate the package is for the intended recipient:
 *  - Package is for a not registered user, redirect to registration page
 *  - Package is for a saml user
 *    - if already logged in, validate user email with the intended recipient and redirect either to package details or an error page
 *    - if not logged in, force a saml login and redirect to the updated "received" page for validation
 *  - Package is for an external user
 *    - if already logged in, validate user email with the intended recipient and redirect either to package details or an error page
 *    - if not logged in, force a saml login and redirect to the updated "received" page for validation
 */
var DeliveryPage = /** @class */ (function (_super) {
    __extends(DeliveryPage, _super);
    function DeliveryPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        return _this;
    }
    DeliveryPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var search, _a, faspexUrl, recipientEmail, context, validateDeliveryResponse, errorUrl, loginRedirectUrl, redirectUrl, jwt, decodedJwt, jwt, decodedJwt;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        search = this.props.location.search;
                        if (!search) {
                            return [2 /*return*/, this.setState({ isValidRequest: false, validating: false })];
                        }
                        _a = query_string_1.default.parse(search), faspexUrl = _a.faspexUrl, recipientEmail = _a.recipient;
                        context = faspexUrlHelper_1.parseContextUrl(faspexUrl).context;
                        return [4 /*yield*/, PackagesApi.validateDelivery(context)];
                    case 1:
                        validateDeliveryResponse = _b.sent();
                        errorUrl = "/error/" + constants_1.EMAIL_MISMATCH;
                        loginRedirectUrl = this.state.redirectUrl + "/packages/received/" + validateDeliveryResponse.id + "?recipient=" + recipientEmail;
                        redirectUrl = this.state.redirectUrl + "/packages/" + validateDeliveryResponse.id;
                        if (validateDeliveryResponse.passcode) {
                            // External non-registered user
                            this.setState({
                                context: context,
                                email: validateDeliveryResponse.email,
                                isValidRequest: true,
                                redirectUrl: redirectUrl,
                                validating: false
                            });
                            // Log.debug('DELIVERY FOR A NEW USER');
                        }
                        else if (validateDeliveryResponse.saml_provider) {
                            jwt = sessionStorage.getItem(constants_1.JWT_STORAGE_KEY);
                            if (jwt) {
                                decodedJwt = utils_1.decodeJwt(jwt);
                                // Log.debug(`USER ALREADY LOGGED IN`);
                                if (decodedJwt.auth.user.userEmail === recipientEmail) {
                                    // Log.debug('REDIRECTING TO PACKAGE');
                                    window.location.assign(redirectUrl);
                                }
                                else {
                                    // Log.debug('REDIRECTING TO ERROR');
                                    window.location.assign(errorUrl);
                                }
                            }
                            else {
                                // Log.debug('LOGGING IN SAML USER');
                                window.location.assign("/auth/saml?saml_provider=" + validateDeliveryResponse.saml_provider + "&redirectTo=" + encodeURIComponent(loginRedirectUrl || ''));
                            }
                        }
                        else {
                            jwt = sessionStorage.getItem(constants_1.JWT_STORAGE_KEY);
                            if (jwt) {
                                decodedJwt = utils_1.decodeJwt(jwt);
                                // Log.debug(`USER ALREADY LOGGED IN`);
                                if (decodedJwt.auth.user.userEmail === recipientEmail) {
                                    // Log.debug('REDIRECTING TO PACKAGE');
                                    this.setState({
                                        isValidRequest: true,
                                        redirectUrl: redirectUrl,
                                        validating: false
                                    });
                                }
                                else {
                                    // Log.debug('REDIRECTING TO ERROR');
                                    this.setState({
                                        isValidRequest: true,
                                        redirectUrl: errorUrl,
                                        validating: false
                                    });
                                }
                            }
                            else {
                                // Log.debug('LOGGING IN EXTERNAL USER');
                                this.setState({
                                    isValidRequest: true,
                                    redirectUrl: loginRedirectUrl,
                                    validating: false
                                });
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DeliveryPage.prototype.render = function () {
        var _a = this.state, context = _a.context, validating = _a.validating, email = _a.email, isValidRequest = _a.isValidRequest, redirectUrl = _a.redirectUrl;
        if (validating) {
            return react_1.default.createElement("div", null, "Loading...");
        }
        if (email && context) {
            return react_1.default.createElement(react_router_1.Redirect, { to: { pathname: "/register/" + email, search: "?context=" + context } });
        }
        else if (!isValidRequest) {
            return react_1.default.createElement("div", null, "Invalid Request!");
        }
        else {
            return react_1.default.createElement(react_router_1.Redirect, { to: { pathname: redirectUrl } });
        }
    };
    return DeliveryPage;
}(react_1.Component));
exports.DeliveryPage = DeliveryPage;
